// Web replacement for @react-native-firebase/messaging.
// TODO(pwa): web push via firebase/messaging + service worker. Until then push is reported as unavailable.
export namespace FirebaseMessagingTypes {
  export type RemoteMessage = {
    messageId?: string;
    data?: Record<string, string>;
    notification?: { title?: string; body?: string };
  };
}

const AuthorizationStatus = {
  NOT_DETERMINED: -1,
  DENIED: 0,
  AUTHORIZED: 1,
  PROVISIONAL: 2,
  EPHEMERAL: 3,
} as const;

const noopUnsubscribe = () => {};

const module = {
  async hasPermission() {
    return AuthorizationStatus.DENIED;
  },
  async requestPermission() {
    return AuthorizationStatus.DENIED;
  },
  // No token yet: notifications.ts treats an empty token as "push unavailable" and skips registration quietly.
  async getToken(): Promise<string> {
    return '';
  },
  async deleteToken() {},
  onTokenRefresh(_listener: (token: string) => void) {
    return noopUnsubscribe;
  },
  onMessage(_listener: (message: FirebaseMessagingTypes.RemoteMessage) => void) {
    return noopUnsubscribe;
  },
  onNotificationOpenedApp(_listener: (message: FirebaseMessagingTypes.RemoteMessage) => void) {
    return noopUnsubscribe;
  },
  async getInitialNotification() {
    return null;
  },
  setBackgroundMessageHandler(_handler: unknown) {},
};

function messaging() {
  return module;
}
messaging.AuthorizationStatus = AuthorizationStatus;

export default messaging;
